module.exports = __webpack_public_path__ + "static/img/14000316.6ad0714b.png";